// Copyright 2024 - MinIO, Inc. All rights reserved.

import { Api } from "./directpvApi";

export let rootDpvApi = new Api();
